import React from 'react'
import { strings } from '../../../../../../i18n.js'
import { getCurrencyType } from '../../../../../../services/getCurrencyType.js'
import CurrencyName from '../../../../../elements/currency.js'
import Selector from './Selector.jsx'
import classes from './style.module.css'

const WrapperSelector = (props) => {

    const {
        inCurrencyModal,
        outCurrencyModal,
        paywayModal,
        state,
    } = props

    const typeInCurrency = getCurrencyType(state.inCurrency)
    const typeOutCurrency = getCurrencyType(state.outCurrency)
    
    return (
        <div className={classes.selectors__wrapper}>
            <Selector
                width={!state.inCurrency || !state.outCurrency ? '48%' : (state.inCurrency && typeInCurrency === 'FIAT') ||
                    (state.outCurrency && typeOutCurrency === 'FIAT') ? '31%' : '48%'}
                description={strings('mobileExchanger.youGive')}
                descriptionIcon='ARROW_SEND'
                mainIcon={state.inCurrency ?
                    <CurrencyName currencyCode={state.inCurrency} /> ? state.inCurrency : 'DEFAULT_COIN' : null}
                onClick={inCurrencyModal}
                name={(state.inCurrency && typeInCurrency !== 'FIAT' && (!state.outCurrency || typeOutCurrency !== 'FIAT')) ? state.inCurrency : null}
                select={state.inCurrency === null}
                type={state.inCurrency ? typeInCurrency : null}
            />
            <Selector
                width={!state.outCurrency || !state.inCurrency ? '48%' : (state.inCurrency && typeInCurrency === 'FIAT') ||
                    (state.outCurrency && typeOutCurrency === 'FIAT') ? '31%' : '48%'}
                description={strings('mobileExchanger.youGet')}
                descriptionIcon='ARROW_RECEIVE'
                mainIcon={state.outCurrency ?
                    <CurrencyName currencyCode={state.outCurrency} /> ? state.outCurrency : 'DEFAULT_COIN' : null}
                onClick={outCurrencyModal}
                name={(state.inCurrency && typeInCurrency !== 'FIAT' && (!state.outCurrency || typeOutCurrency !== 'FIAT')) ? state.outCurrency : null}
                select={state.outCurrency === null}
                type={state.outCurrency ? typeOutCurrency: null}
            />
            {state.inCurrency && state.outCurrency && (typeInCurrency === 'FIAT' || typeOutCurrency === 'FIAT') &&
                <Selector
                    width='30%'
                    description={strings('mobileExchanger.payway')}
                    descriptionIcon='PAYWAY'
                    mainIcon={state.payway === 'MOBILE_PHONE' ? 'MOBILE' : state.payway}
                    onClick={paywayModal}
                    select={!state.payway}
                    type={state.payway ? 'PAYWAY' : null}
                />
            }

        </div>
    )
}

export default WrapperSelector